/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { ILanguagePackItem, LanguagePackBaseService } from 'vs/platform/languagePacks/common/languagePacks';
import { ProxyChannel } from 'vs/base/parts/ipc/common/ipc';
import { ILanguagePackService } from 'vs/platform/languagePacks/common/languagePacks';
import { IRemoteAgentService } from 'vs/workbench/services/remote/common/remoteAgentService';
import { IExtensionGalleryService } from 'vs/platform/extensionManagement/common/extensionManagement';

export class WebLanguagePacksService extends LanguagePackBaseService {
	private readonly languagePackService: ILanguagePackService;

	constructor(
		@IRemoteAgentService remoteAgentService: IRemoteAgentService,
		@IExtensionGalleryService extensionGalleryService: IExtensionGalleryService
	) {
		super(extensionGalleryService)
		this.languagePackService = ProxyChannel.toService<ILanguagePackService>(remoteAgentService.getConnection()!.getChannel('languagePacks'));
	}

	getInstalledLanguages(): Promise<ILanguagePackItem[]> {
		return this.languagePackService.getInstalledLanguages()
	}
}
